module.exports = __webpack_public_path__ + "img/ssabu.cb741d65.jpeg";